import { cn } from "../lib/utils";

/**
 * Custom progress steps component for carrier onboarding
 */
export const ProgressSteps: React.FC<{ activeStep: number; numberOfSteps: number }> = ({ numberOfSteps, activeStep }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      {Array.from({ length: numberOfSteps }, (_, index) => (
        <div
          key={index}
          className={cn(
            'h-2 w-8 rounded-full transition-colors duration-200',
            index < activeStep ? 'bg-blue-500' : 'bg-gray-200 dark:bg-gray-700'
          )}
        />
      ))}
    </div>
  )
}